export { default } from './Divider';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Divider/index.js
// module id = 669
// module chunks = 0